/**
 * Regions Configuration
 * Multi-select support with countries, parent regions and sub-regions
 */

// Countries configuration - European + Global
export const COUNTRIES = [
  // Europe
  { id: 'DK', code: 'DK', name: 'Danmark', flag: '🇩🇰' },
  { id: 'DE', code: 'DE', name: 'Tyskland', flag: '🇩🇪' },
  { id: 'SE', code: 'SE', name: 'Sverige', flag: '🇸🇪' },
  { id: 'NO', code: 'NO', name: 'Norge', flag: '🇳🇴' },
  { id: 'NL', code: 'NL', name: 'Holland', flag: '🇳🇱' },
  { id: 'GB', code: 'GB', name: 'England', flag: '🇬🇧' },
  { id: 'ES', code: 'ES', name: 'Spanien', flag: '🇪🇸' },
  { id: 'IT', code: 'IT', name: 'Italien', flag: '🇮🇹' },
  { id: 'FR', code: 'FR', name: 'Frankrig', flag: '🇫🇷' },
  { id: 'BE', code: 'BE', name: 'Belgien', flag: '🇧🇪' },
  { id: 'AT', code: 'AT', name: 'Østrig', flag: '🇦🇹' },
  { id: 'CH', code: 'CH', name: 'Schweiz', flag: '🇨🇭' },
  { id: 'PL', code: 'PL', name: 'Polen', flag: '🇵🇱' },
  { id: 'CZ', code: 'CZ', name: 'Tjekkiet', flag: '🇨🇿' },
  { id: 'PT', code: 'PT', name: 'Portugal', flag: '🇵🇹' },
  { id: 'IE', code: 'IE', name: 'Irland', flag: '🇮🇪' },
  { id: 'LU', code: 'LU', name: 'Luxembourg', flag: '🇱🇺' },
  { id: 'FI', code: 'FI', name: 'Finland', flag: '🇫🇮' },
  { id: 'GR', code: 'GR', name: 'Grækenland', flag: '🇬🇷' },
  { id: 'HR', code: 'HR', name: 'Kroatien', flag: '🇭🇷' },
  { id: 'SI', code: 'SI', name: 'Slovenien', flag: '🇸🇮' },
  { id: 'SK', code: 'SK', name: 'Slovakiet', flag: '🇸🇰' },
  { id: 'HU', code: 'HU', name: 'Ungarn', flag: '🇭🇺' },
  { id: 'RO', code: 'RO', name: 'Rumænien', flag: '🇷🇴' },
  { id: 'BG', code: 'BG', name: 'Bulgarien', flag: '🇧🇬' },
  { id: 'RS', code: 'RS', name: 'Serbien', flag: '🇷🇸' },
  { id: 'BA', code: 'BA', name: 'Bosnien', flag: '🇧🇦' },
  { id: 'ME', code: 'ME', name: 'Montenegro', flag: '🇲🇪' },
  { id: 'AL', code: 'AL', name: 'Albanien', flag: '🇦🇱' },
  { id: 'MK', code: 'MK', name: 'Nordmakedonien', flag: '🇲🇰' },
  { id: 'EE', code: 'EE', name: 'Estland', flag: '🇪🇪' },
  { id: 'LV', code: 'LV', name: 'Letland', flag: '🇱🇻' },
  { id: 'LT', code: 'LT', name: 'Litauen', flag: '🇱🇹' },
  { id: 'IS', code: 'IS', name: 'Island', flag: '🇮🇸' },
  { id: 'MT', code: 'MT', name: 'Malta', flag: '🇲🇹' },
  { id: 'CY', code: 'CY', name: 'Cypern', flag: '🇨🇾' },
  { id: 'UA', code: 'UA', name: 'Ukraine', flag: '🇺🇦' },
  { id: 'TR', code: 'TR', name: 'Tyrkiet', flag: '🇹🇷' },
  { id: 'MD', code: 'MD', name: 'Moldova', flag: '🇲🇩' },
  { id: 'BY', code: 'BY', name: 'Belarus', flag: '🇧🇾' },
  { id: 'GE', code: 'GE', name: 'Georgien', flag: '🇬🇪' },
  { id: 'AM', code: 'AM', name: 'Armenien', flag: '🇦🇲' },
  { id: 'AZ', code: 'AZ', name: 'Aserbajdsjan', flag: '🇦🇿' },
  { id: 'RU', code: 'RU', name: 'Rusland', flag: '🇷🇺' },
  { id: 'AD', code: 'AD', name: 'Andorra', flag: '🇦🇩' },
  { id: 'LI', code: 'LI', name: 'Liechtenstein', flag: '🇱🇮' },
  { id: 'MC', code: 'MC', name: 'Monaco', flag: '🇲🇨' },
  { id: 'SM', code: 'SM', name: 'San Marino', flag: '🇸🇲' },
  { id: 'XK', code: 'XK', name: 'Kosovo', flag: '🇽🇰' },
  // Americas
  { id: 'US', code: 'US', name: 'USA', flag: '🇺🇸' },
  { id: 'CA', code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { id: 'MX', code: 'MX', name: 'Mexico', flag: '🇲🇽' },
  { id: 'BR', code: 'BR', name: 'Brasilien', flag: '🇧🇷' },
  { id: 'AR', code: 'AR', name: 'Argentina', flag: '🇦🇷' },
  { id: 'CO', code: 'CO', name: 'Colombia', flag: '🇨🇴' },
  { id: 'CL', code: 'CL', name: 'Chile', flag: '🇨🇱' },
  // Asia & Oceania
  { id: 'JP', code: 'JP', name: 'Japan', flag: '🇯🇵' },
  { id: 'TH', code: 'TH', name: 'Thailand', flag: '🇹🇭' },
  { id: 'IN', code: 'IN', name: 'Indien', flag: '🇮🇳' },
  { id: 'AU', code: 'AU', name: 'Australien', flag: '🇦🇺' },
  { id: 'NZ', code: 'NZ', name: 'New Zealand', flag: '🇳🇿' },
  { id: 'ZA', code: 'ZA', name: 'Sydafrika', flag: '🇿🇦' },
  { id: 'MA', code: 'MA', name: 'Marokko', flag: '🇲🇦' },
  { id: 'IL', code: 'IL', name: 'Israel', flag: '🇮🇱' },
  { id: 'AE', code: 'AE', name: 'UAE', flag: '🇦🇪' },
];

// German states (Bundesländer)
export const GERMAN_REGIONS = [
  { id: 'DE-SH', label: 'Schleswig-Holstein', country: 'DE' },
  { id: 'DE-HH', label: 'Hamburg', country: 'DE' },
  { id: 'DE-NI', label: 'Niedersachsen', country: 'DE' },
  { id: 'DE-HB', label: 'Bremen', country: 'DE' },
  { id: 'DE-NW', label: 'Nordrhein-Westfalen', country: 'DE' },
  { id: 'DE-HE', label: 'Hessen', country: 'DE' },
  { id: 'DE-RP', label: 'Rheinland-Pfalz', country: 'DE' },
  { id: 'DE-BW', label: 'Baden-Württemberg', country: 'DE' },
  { id: 'DE-BY', label: 'Bayern', country: 'DE' },
  { id: 'DE-SL', label: 'Saarland', country: 'DE' },
  { id: 'DE-BE', label: 'Berlin', country: 'DE' },
  { id: 'DE-BB', label: 'Brandenburg', country: 'DE' },
  { id: 'DE-MV', label: 'Mecklenburg-Vorpommern', country: 'DE' },
  { id: 'DE-SN', label: 'Sachsen', country: 'DE' },
  { id: 'DE-ST', label: 'Sachsen-Anhalt', country: 'DE' },
  { id: 'DE-TH', label: 'Thüringen', country: 'DE' },
];

// Swedish regions
export const SWEDISH_REGIONS = [
  { id: 'SE-M', label: 'Skåne', country: 'SE' },
  { id: 'SE-AB', label: 'Stockholm', country: 'SE' },
  { id: 'SE-O', label: 'Västra Götaland', country: 'SE' },
];

// Norwegian regions
export const NORWEGIAN_REGIONS = [
  { id: 'NO-03', label: 'Oslo', country: 'NO' },
  { id: 'NO-30', label: 'Viken', country: 'NO' },
  { id: 'NO-46', label: 'Vestland', country: 'NO' },
];

// Dutch provinces (Netherlands)
export const DUTCH_REGIONS = [
  { id: 'NL-NH', label: 'Noord-Holland', country: 'NL' },
  { id: 'NL-ZH', label: 'Zuid-Holland', country: 'NL' },
  { id: 'NL-NB', label: 'Noord-Brabant', country: 'NL' },
  { id: 'NL-GE', label: 'Gelderland', country: 'NL' },
  { id: 'NL-LI', label: 'Limburg', country: 'NL' },
  { id: 'NL-OV', label: 'Overijssel', country: 'NL' },
  { id: 'NL-FL', label: 'Flevoland', country: 'NL' },
  { id: 'NL-UT', label: 'Utrecht', country: 'NL' },
  { id: 'NL-FR', label: 'Friesland', country: 'NL' },
  { id: 'NL-GR', label: 'Groningen', country: 'NL' },
  { id: 'NL-DR', label: 'Drenthe', country: 'NL' },
  { id: 'NL-ZE', label: 'Zeeland', country: 'NL' },
];

// English regions (England)
export const ENGLISH_REGIONS = [
  { id: 'GB-LON', label: 'London', country: 'GB' },
  { id: 'GB-NW', label: 'North West', country: 'GB' },
  { id: 'GB-NE', label: 'North East', country: 'GB' },
  { id: 'GB-YH', label: 'Yorkshire', country: 'GB' },
  { id: 'GB-WM', label: 'West Midlands', country: 'GB' },
  { id: 'GB-EM', label: 'East Midlands', country: 'GB' },
  { id: 'GB-EE', label: 'East of England', country: 'GB' },
  { id: 'GB-SE', label: 'South East', country: 'GB' },
  { id: 'GB-SW', label: 'South West', country: 'GB' },
];

export const REGION_GROUPS = {
  jylland: {
    id: 'jylland',
    label: 'Jylland',
    subRegions: [
      { id: 'Nordjylland', label: 'Nordjylland' },
      { id: 'Midtjylland', label: 'Midtjylland' },
      { id: 'Syddanmark', label: 'Sydjylland' }
    ]
  },
  sjaelland: {
    id: 'sjaelland',
    label: 'Sjælland',
    subRegions: [
      { id: 'Hovedstaden', label: 'Hovedstaden/København' },
      { id: 'Sjælland', label: 'Øvrige Sjælland' }
    ]
  },
  fyn: {
    id: 'fyn',
    label: 'Fyn',
    subRegions: [
      { id: 'Syddanmark', label: 'Fyn' } // Fyn is part of Syddanmark region
    ]
  },
  bornholm: {
    id: 'bornholm',
    label: 'Bornholm',
    subRegions: [
      { id: 'Hovedstaden', label: 'Bornholm' } // Bornholm is part of Hovedstaden region
    ]
  }
};

// All individual regions for filtering (Danish regions)
export const ALL_REGIONS = [
  { id: 'Nordjylland', label: 'Nordjylland', group: 'jylland', country: 'DK' },
  { id: 'Midtjylland', label: 'Midtjylland', group: 'jylland', country: 'DK' },
  { id: 'Syddanmark', label: 'Syddanmark', group: 'jylland', country: 'DK' },
  { id: 'Sjælland', label: 'Sjælland', group: 'sjaelland', country: 'DK' },
  { id: 'Hovedstaden', label: 'Hovedstaden', group: 'sjaelland', country: 'DK' }
];

// Grouped regions for multi-select UI
export const REGION_SELECTOR_OPTIONS = [
  { 
    type: 'group', 
    id: 'jylland', 
    label: 'Jylland',
    regions: ['Nordjylland', 'Midtjylland', 'Syddanmark']
  },
  { type: 'region', id: 'Nordjylland', label: 'Nordjylland', indent: true },
  { type: 'region', id: 'Midtjylland', label: 'Midtjylland', indent: true },
  { type: 'region', id: 'Syddanmark', label: 'Sydjylland/Fyn', indent: true },
  { type: 'divider' },
  { 
    type: 'group', 
    id: 'sjaelland', 
    label: 'Sjælland & Øerne',
    regions: ['Sjælland', 'Hovedstaden']
  },
  { type: 'region', id: 'Hovedstaden', label: 'Hovedstaden/København', indent: true },
  { type: 'region', id: 'Sjælland', label: 'Øvrige Sjælland', indent: true }
];

// Quick select options for common searches
export const QUICK_REGIONS = [
  { id: 'all', label: 'Hele Danmark', regions: [] },
  { id: 'jylland', label: 'Hele Jylland', regions: ['Nordjylland', 'Midtjylland', 'Syddanmark'] },
  { id: 'sjaelland_all', label: 'Hele Sjælland', regions: ['Sjælland', 'Hovedstaden'] },
  { id: 'fyn_area', label: 'Fyn-området', regions: ['Syddanmark'] }
];

/**
 * Check if a club matches the selected regions
 * @param {Object} club - Club object with region property
 * @param {Array} selectedRegions - Array of selected region IDs
 * @returns {boolean}
 */
export const clubMatchesRegions = (club, selectedRegions) => {
  if (!selectedRegions || selectedRegions.length === 0) {
    return true; // No filter = show all
  }
  // Always show clubs without region or international clubs
  if (!club.region || club.region.startsWith('international_')) {
    return true;
  }
  return selectedRegions.includes(club.region);
};

/**
 * Get display text for selected regions
 * @param {Array} selectedRegions - Array of selected region IDs
 * @param {Function} t - Translation function (optional)
 * @returns {string}
 */
export const getRegionsDisplayText = (selectedRegions, t = null) => {
  // Helper to get translation or fallback
  const getText = (key, fallback) => t ? t(key) : fallback;
  
  if (!selectedRegions || selectedRegions.length === 0) {
    return getText('regions.allRegions', 'Alle regioner');
  }
  
  if (selectedRegions.length === 5) {
    return getText('regions.allDenmark', 'Hele Danmark');
  }
  
  // Check for group selections
  const jyllandRegions = ['Nordjylland', 'Midtjylland', 'Syddanmark'];
  const sjaellandRegions = ['Sjælland', 'Hovedstaden'];
  
  const hasAllJylland = jyllandRegions.every(r => selectedRegions.includes(r));
  const hasAllSjaelland = sjaellandRegions.every(r => selectedRegions.includes(r));
  
  const parts = [];
  
  if (hasAllJylland) {
    parts.push(getText('regions.jylland', 'Jylland'));
  } else {
    jyllandRegions.forEach(r => {
      if (selectedRegions.includes(r)) {
        const region = ALL_REGIONS.find(reg => reg.id === r);
        parts.push(region?.label || r);
      }
    });
  }
  
  if (hasAllSjaelland) {
    parts.push(getText('regions.sjaelland', 'Sjælland'));
  } else {
    sjaellandRegions.forEach(r => {
      if (selectedRegions.includes(r)) {
        const region = ALL_REGIONS.find(reg => reg.id === r);
        parts.push(region?.label || r);
      }
    });
  }
  
  if (parts.length > 2) {
    return `${parts.length} ${getText('regions.regionsSelected', 'regioner')}`;
  }
  
  return parts.join(', ');
};

/**
 * Toggle a region in the selection
 * @param {Array} currentSelection - Current selected regions
 * @param {string} regionId - Region to toggle
 * @returns {Array} - New selection
 */
export const toggleRegion = (currentSelection, regionId) => {
  if (currentSelection.includes(regionId)) {
    return currentSelection.filter(r => r !== regionId);
  }
  return [...currentSelection, regionId];
};

/**
 * Toggle a group of regions
 * @param {Array} currentSelection - Current selected regions
 * @param {string} groupId - Group ID (jylland, sjaelland_all)
 * @returns {Array} - New selection
 */
export const toggleRegionGroup = (currentSelection, groupId) => {
  const group = QUICK_REGIONS.find(g => g.id === groupId);
  if (!group) return currentSelection;
  
  const groupRegions = group.regions;
  const hasAllFromGroup = groupRegions.every(r => currentSelection.includes(r));
  
  if (hasAllFromGroup) {
    // Remove all from group
    return currentSelection.filter(r => !groupRegions.includes(r));
  } else {
    // Add all from group
    const newSelection = [...currentSelection];
    groupRegions.forEach(r => {
      if (!newSelection.includes(r)) {
        newSelection.push(r);
      }
    });
    return newSelection;
  }
};
